document.addEventListener("DOMContentLoaded", function () {
    const carousels = document.querySelectorAll(".doctor-training .carousel");
    if (!carousels.length) return;

    carousels.forEach((carousel) => {
        const track = carousel.querySelector(".carousel-track");
        const items = track ? track.querySelectorAll(":scope > li") : [];
        const prevBtn = carousel.querySelector(".carousel-btn.prev");
        const nextBtn = carousel.querySelector(".carousel-btn.next");

        if (!track || !items.length || !prevBtn || !nextBtn) return;

        let index = 0;
        let itemWidth = 0;
        let maxIndex = 0;
        let itemsVisible = 4;
        let startX = 0;
        let currentTranslate = 0;
        let prevTranslate = 0;
        let dragging = false;
        let dragDistance = 0;
        const dragThreshold = 6;

        function calc() {
            const w = window.innerWidth;
            itemsVisible = w <= 768 ? 1 : w <= 1100 ? 2 : 4;

            const gap = parseFloat(getComputedStyle(track).gap || 0);
            itemWidth = items[0].offsetWidth + gap;

            maxIndex = Math.max(0, items.length - itemsVisible);
            index = Math.min(index, maxIndex);

            prevTranslate = -index * itemWidth;
            currentTranslate = prevTranslate;

            track.style.transform = `translateX(${prevTranslate}px)`;
            updateButtons();
        }

        function updateButtons() {
            prevBtn.disabled = index === 0;
            nextBtn.disabled = index === maxIndex;
        }

        function goTo(i) {
            index = Math.max(0, Math.min(i, maxIndex));
            prevTranslate = -index * itemWidth;
            currentTranslate = prevTranslate;
            track.style.transition = "transform .3s ease";
            track.style.transform = `translateX(${prevTranslate}px)`;
            updateButtons();
        }

        prevBtn.onclick = () => goTo(index - 1);
        nextBtn.onclick = () => goTo(index + 1);

        function dragStart(x) {
            dragging = true;
            startX = x;
            dragDistance = 0;
            track.style.transition = "none";
            carousel.classList.add("dragging");
        }

        function dragMove(x) {
            if (!dragging) return;
            const delta = x - startX;
            dragDistance = Math.max(dragDistance, Math.abs(delta));
            currentTranslate = prevTranslate + delta;
            track.style.transform = `translateX(${currentTranslate}px)`;
        }

        function dragEnd() {
            if (!dragging) return;
            dragging = false;
            carousel.classList.remove("dragging");
            index = Math.round(Math.abs(currentTranslate) / itemWidth);
            goTo(index);
        }

        carousel.addEventListener("mousedown", (e) => {
            if (e.button !== 0) return;
            e.preventDefault();
            dragStart(e.clientX);
        });
        window.addEventListener("mousemove", (e) => {
            if (!dragging) return;
            e.preventDefault();
            dragMove(e.clientX);
        });
        window.addEventListener("mouseup", dragEnd);

        carousel.addEventListener("touchstart", (e) => dragStart(e.touches[0].clientX));
        carousel.addEventListener("touchmove", (e) => dragMove(e.touches[0].clientX));
        carousel.addEventListener("touchend", dragEnd);
        carousel.addEventListener("dragstart", (e) => e.preventDefault());
        carousel.addEventListener("click", (e) => {
            if (dragDistance > dragThreshold) {
                e.preventDefault();
                e.stopPropagation();
            }
        });

        window.addEventListener("resize", calc);
        calc();
    });
});